import { designToken, quickProperty } from '../component-tokens';
export const tooltipData = {
    name: 'tooltip',
    tag: 'chameleon-tooltip',
    reactImports: 'Tooltip',
    attributes: {
        display: quickProperty('inline-flex'),
        'border-radius': designToken('radius-small'),
        font: designToken('caption-medium'),
        color: designToken('type-color-inverted'),
        'background-color': designToken('surface-color-inverted'),
        padding: quickProperty('0.25rem 0.5rem'),
    },
};
